export default "b589f7da1938be2e.svg"